var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _path9, _g6, _path0, _g7, _path1, _g8, _path10, _g9, _path11, _g0, _path12, _path13, _g1, _path14, _path15, _g10, _path16, _path17, _g11, _path18, _g12, _path19, _g13, _g14, _path20, _path21, _g15, _path22, _path23, _g16, _path24, _g17, _path25, _g18, _g19, _path26, _path27, _g20, _path28, _path29, _g21, _path30, _g22, _path31, _g23, _path32, _g24, _g25, _path33, _g26, _g27, _path34, _g28, _path35, _path36, _g29, _path37, _path38, _g30, _path39, _g31, _path40, _path41, _g32, _path42, _path43, _g33, _path44, _g34, _path45, _path46, _g35, _path47, _g36, _path48, _g37, _g38, _path49, _path50, _g39, _path51, _g40, _path52, _g41, _g42, _path53, _path54, _g43, _path55, _g44, _path56, _path57, _g45, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g46, _path76, _path77, _g47, _path78, _path79, _path80, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiraffeExcited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_181806)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_197_181806)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.03 321C214.723 321 259.06 314.989 259.06 307.573C259.06 300.158 214.723 294.146 160.03 294.146C105.337 294.146 61 300.158 61 307.573C61 314.989 105.337 321 160.03 321Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 150,
    width: 57,
    height: 56
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.202 152.984C84.3228 152.923 84.7458 153.105 84.8062 153.165C85.5313 153.347 86.1959 153.589 86.8605 153.831C88.9148 154.617 90.9087 155.585 92.7818 156.613C93.2047 156.855 94.0506 157.036 94.4132 157.338C94.5944 157.218 94.2923 157.762 94.2319 158.004C94.1111 158.427 93.9902 158.85 93.8694 159.274C93.5068 160.604 93.2047 161.935 92.9631 163.326C92.1776 167.318 91.6942 171.43 91.1504 175.483C90.9087 177.237 90.667 178.991 90.4254 180.745C90.2441 182.257 90.0628 183.769 89.8816 185.281C89.1565 191.813 88.0085 200.34 95.0778 203.788C96.2258 204.332 97.4946 204.755 98.7635 204.997C100.455 205.3 102.268 205.239 104.02 204.997C103.839 204.816 103.839 205.481 103.718 205.723C103.537 206.207 103.235 206.691 102.933 207.175C101.966 208.566 100.818 209.654 99.3677 210.38C95.3195 212.376 88.794 212.013 84.927 209.836C79.4891 206.751 77.9786 199.736 77.3744 194.05C75.9847 181.047 78.1599 168.346 81.1809 155.766L84.202 152.984Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 150,
    width: 57,
    height: 56
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.757 167.62C120.696 167.802 119.911 167.983 119.79 168.043C118.823 168.467 117.857 168.951 116.89 169.435C114.473 170.584 112.056 171.793 109.7 173.124C108.733 173.668 108.008 174.394 107.102 174.938C107.102 174.938 105.954 180.261 105.289 183.043C105.289 183.103 107.223 180.744 108.31 178.688C108.431 178.688 126.134 168.951 127.282 168.346L120.757 167.62Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 150,
    width: 57,
    height: 56
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.887 200.099C109.337 197.619 108.551 194.414 106.135 192.962C103.657 191.511 100.455 192.297 99.0049 194.777C97.5548 197.256 98.3403 200.462 100.757 201.913C103.174 203.425 106.376 202.579 107.887 200.099Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 150,
    width: 57,
    height: 56
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.852 188.486C121.06 186.49 120.456 184.011 118.583 182.862C116.71 181.712 114.233 182.438 113.024 184.434C111.816 186.43 112.42 188.91 114.293 190.059C116.227 191.147 118.704 190.422 119.852 188.486Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 150,
    width: 57,
    height: 56
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.601 185.704C136.468 184.495 139.368 181.047 139.731 176.753C140.033 173.306 138.764 170.645 136.77 168.649C136.105 167.983 131.393 163.568 124.384 166.834C122.148 167.863 114.354 172.157 106.801 176.39C108.01 168.528 109.097 163.145 109.097 163.145C110.185 157.581 106.62 152.138 101.061 151.049C95.5024 149.96 90.0645 153.529 88.9769 159.093C88.9769 159.093 85.5933 175.967 83.9015 194.172C83.5994 197.68 84.8079 200.341 86.8018 202.397C87.4664 203.062 92.1792 207.538 99.2485 204.212C103.538 202.155 129.399 187.458 132.601 185.704Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2554 186.975C98.1013 185.523 97.6783 183.588 96.2282 182.741C94.7781 181.894 92.9051 182.318 91.9988 183.83C91.1529 185.281 91.5758 187.216 93.0259 188.063C94.476 188.97 96.3491 188.487 97.2554 186.975Z",
    fill: "#673620"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 150,
    width: 57,
    height: 56
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.861 152.984C235.74 152.923 235.317 153.105 235.257 153.165C234.532 153.347 233.867 153.589 233.203 153.831C231.148 154.617 229.154 155.585 227.281 156.613C226.858 156.855 226.012 157.036 225.65 157.338C225.469 157.218 225.771 157.762 225.831 158.004C225.952 158.427 226.073 158.85 226.194 159.274C226.556 160.604 226.858 161.935 227.1 163.326C227.885 167.318 228.369 171.43 228.913 175.483C229.154 177.237 229.396 178.991 229.638 180.745C229.819 182.257 230 183.769 230.182 185.281C230.907 191.813 232.055 200.34 224.985 203.788C223.837 204.332 222.568 204.755 221.3 204.997C219.608 205.3 217.795 205.239 216.043 204.997C216.224 204.816 216.224 205.481 216.345 205.723C216.526 206.207 216.828 206.691 217.131 207.175C218.097 208.566 219.185 209.654 220.695 210.38C224.744 212.376 231.269 212.013 235.136 209.836C240.574 206.751 242.084 199.736 242.689 194.05C244.078 181.047 241.903 168.346 238.882 155.766L235.861 152.984Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 150,
    width: 57,
    height: 56
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.244 167.62C199.305 167.802 200.09 167.983 200.211 168.043C201.178 168.467 202.144 168.951 203.111 169.435C205.528 170.584 207.945 171.793 210.301 173.124C211.268 173.668 211.993 174.394 212.899 174.938C212.839 174.938 214.047 180.261 214.712 183.043C214.712 183.103 212.779 180.744 211.691 178.688C211.57 178.688 193.867 168.951 192.719 168.346L199.244 167.62Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 150,
    width: 57,
    height: 56
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.177 200.099C210.727 197.619 211.512 194.414 213.929 192.962C216.406 191.511 219.609 192.297 221.059 194.777C222.509 197.256 221.723 200.462 219.306 201.913C216.829 203.425 213.627 202.579 212.177 200.099Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 150,
    width: 57,
    height: 56
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.153 188.486C198.945 186.49 199.549 184.011 201.422 182.862C203.295 181.712 205.773 182.438 206.981 184.434C208.189 186.43 207.585 188.91 205.712 190.059C203.839 191.147 201.362 190.422 200.153 188.486Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 150,
    width: 57,
    height: 56
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M187.463 185.704C183.596 184.495 180.696 181.047 180.333 176.753C180.031 173.306 181.3 170.645 183.294 168.649C183.959 167.983 188.672 163.568 195.68 166.834C197.916 167.863 205.71 172.157 213.263 176.39C212.055 168.528 210.967 163.145 210.967 163.145C209.879 157.581 213.444 152.138 219.003 151.049C224.562 149.96 230 153.529 231.087 159.093C231.087 159.093 234.471 175.967 236.163 194.172C236.465 197.68 235.256 200.341 233.262 202.397C232.598 203.062 227.885 207.538 220.816 204.212C216.465 202.155 190.605 187.458 187.463 185.704Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.811 186.975C221.965 185.523 222.388 183.588 223.838 182.741C225.289 181.894 227.162 182.318 228.068 183.83C228.914 185.281 228.491 187.216 227.041 188.063C225.53 188.97 223.657 188.487 222.811 186.975Z",
    fill: "#673620"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.982 254.713C219.483 255.559 211.87 253.382 204.861 248.12C199.544 244.068 194.59 238.201 191.146 230.339L184.258 233.786C188.608 242.858 194.65 249.451 201.055 253.926C209.876 260.035 219.302 262.031 225.948 260.761L224.982 254.713Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 230,
    width: 42,
    height: 32
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M224.982 254.713C219.483 255.559 211.87 253.382 204.861 248.12C199.544 244.068 194.59 238.201 191.146 230.339L184.258 233.786C188.608 242.858 194.65 249.451 201.055 253.926C209.876 260.035 219.302 262.031 225.948 260.761L224.982 254.713Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.764 237.839C189.395 240.621 192.054 243.161 194.289 245.399C200.513 251.568 207.703 256.044 215.981 258.1C218.216 258.644 220.512 259.31 222.869 259.37C223.05 259.37 223.533 259.975 223.654 260.096C224.379 260.701 225.104 261.184 225.89 261.608C228.186 262.878 230.663 263.483 233.261 263.362C238.82 263.18 243.412 259.975 247.037 255.741C248.245 254.35 249.393 252.899 250.541 251.387C250.964 250.782 251.448 250.116 251.871 249.512C251.931 249.451 252.233 248.967 252.354 249.088C252.596 249.391 252.052 250.419 251.931 250.721C251.267 252.475 250.481 254.108 249.575 255.741C245.829 262.394 239.907 267.414 232.355 268.079C228.971 268.382 225.527 267.837 222.446 266.446C220.814 265.721 219.364 264.45 217.733 263.785C214.833 262.696 211.691 262.576 208.79 261.426C199.667 257.737 191.027 250.661 186.012 241.831L187.764 237.839Z",
    fill: "#CE8710"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.287 264.269C220.634 263.18 215.499 256.527 221.42 252.354C229.214 246.79 236.827 251.144 240.513 248.483C240.15 250.479 237.975 252.777 233.081 254.471C232.598 254.652 235.075 254.41 235.498 254.35C238.036 253.926 240.09 252.475 241.842 250.721C245.83 246.79 247.461 247.455 247.401 247.515C243.957 251.87 242.567 256.225 241.178 257.858C235.74 264.329 230.725 265.599 225.287 264.269Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 218,
    y: 247,
    width: 30,
    height: 18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.287 264.269C220.634 263.18 215.499 256.527 221.42 252.354C229.214 246.79 236.827 251.144 240.513 248.483C240.15 250.479 237.975 252.777 233.081 254.471C232.598 254.652 235.075 254.41 235.498 254.35C238.036 253.926 240.09 252.475 241.842 250.721C245.83 246.79 247.461 247.455 247.401 247.515C243.957 251.87 242.567 256.225 241.178 257.858C235.74 264.329 230.725 265.599 225.287 264.269Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.531 238.08C195.558 240.378 197.431 242.616 199.002 244.552C203.353 249.934 208.73 254.047 215.195 256.527C216.947 257.192 218.76 257.918 220.573 258.16C220.693 258.16 221.056 258.704 221.116 258.765C221.6 259.309 222.204 259.732 222.748 260.156C224.44 261.365 226.433 262.091 228.488 262.272C232.959 262.696 237.007 260.7 240.33 257.797C241.418 256.829 242.506 255.861 243.533 254.833C243.956 254.41 244.379 253.926 244.802 253.503C244.862 253.442 245.164 253.14 245.224 253.2C245.345 253.442 244.802 254.228 244.741 254.41C244.076 255.68 243.231 256.89 242.324 258.039C238.699 262.756 233.382 266.022 227.279 265.78C224.56 265.659 221.841 264.934 219.485 263.543C218.216 262.817 217.249 261.668 215.92 261.002C213.685 259.853 211.207 259.49 208.972 258.281C202.023 254.531 195.74 248.241 192.598 240.862L194.531 238.08Z",
    fill: "#301007"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 307.452C148.793 307.452 148.129 269.712 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L148.793 307.452Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 236,
    width: 49,
    height: 72
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 307.452C148.793 307.452 148.129 269.712 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L148.793 307.452Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.816 307.755C112.057 295.296 113.326 260.821 120.033 241.407L153.929 253.08C154.171 252.173 154.473 251.326 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L111.816 307.755Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 236,
    width: 49,
    height: 72
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 307.452C148.793 307.452 148.129 269.712 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L148.793 307.452Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.781 281.567C131.089 281.325 129.518 282.474 129.277 284.167C129.035 285.861 130.183 287.433 131.875 287.675C133.566 287.917 135.137 286.768 135.379 285.075C135.681 283.381 134.473 281.809 132.781 281.567ZM118.159 264.874C114.232 264.874 111.09 268.019 111.09 271.95C111.09 275.882 114.292 279.027 118.159 279.027C122.086 279.027 125.228 275.882 125.228 271.95C125.228 268.019 122.086 264.874 118.159 264.874Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 264,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 264,
    width: 25,
    height: 24
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.781 281.567C131.089 281.325 129.518 282.474 129.277 284.167C129.035 285.861 130.183 287.433 131.875 287.675C133.566 287.917 135.137 286.768 135.379 285.075C135.681 283.381 134.473 281.809 132.781 281.567ZM118.159 264.874C114.232 264.874 111.09 268.019 111.09 271.95C111.09 275.882 114.292 279.027 118.159 279.027C122.086 279.027 125.228 275.882 125.228 271.95C125.228 268.019 122.086 264.874 118.159 264.874Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.793 307.452C148.793 307.452 148.129 269.712 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L148.793 307.452Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.816 307.755C112.057 295.296 113.326 260.821 120.033 241.407L153.929 253.08C154.171 252.173 154.473 251.326 154.775 250.479L115.078 236.811C106.861 260.821 106.801 307.815 106.801 307.815L111.816 307.755Z",
    fill: "#C3A088"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.403 308.601C106.618 308.601 105.893 308.178 105.47 307.512C105.047 306.847 105.047 306 105.409 305.275C109.155 298.682 119.185 293.844 129.396 293.844C139.91 293.844 147.462 298.924 150.242 305.819C150.483 306.424 150.423 307.15 150.061 307.694C149.698 308.238 149.094 308.541 148.429 308.541C140.333 308.601 116.164 308.601 107.403 308.601Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 293,
    width: 46,
    height: 16
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.403 308.601C106.618 308.601 105.893 308.178 105.47 307.512C105.047 306.847 105.047 306 105.409 305.275C109.155 298.682 119.185 293.844 129.396 293.844C139.91 293.844 147.462 298.924 150.242 305.819C150.483 306.424 150.423 307.15 150.061 307.694C149.698 308.238 149.094 308.541 148.429 308.541C140.333 308.601 116.164 308.601 107.403 308.601Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.778 303.219C104.321 304.065 105.288 304.61 106.376 304.61C116.647 304.61 140.634 304.61 150 304.549C150.846 304.549 151.631 304.186 152.114 303.521C152.417 303.945 152.658 304.368 152.9 304.791C153.323 305.578 153.323 306.545 152.84 307.331C152.356 308.118 151.51 308.602 150.544 308.602C140.937 308.662 116.164 308.662 105.651 308.662C104.503 308.662 103.415 307.997 102.932 307.029C102.388 306.001 102.509 304.852 103.234 303.945C103.415 303.642 103.596 303.461 103.778 303.219Z",
    fill: "#301007"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.208 307.452C171.208 307.452 171.873 269.712 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L171.208 307.452Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 49,
    height: 72
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M171.208 307.452C171.208 307.452 171.873 269.712 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L171.208 307.452Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.186 307.755C207.944 295.296 206.675 260.821 199.969 241.407L166.072 253.08C165.831 252.173 165.529 251.326 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L208.186 307.755Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 236,
    width: 49,
    height: 72
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M171.208 307.452C171.208 307.452 171.873 269.712 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L171.208 307.452Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.892 281.567C187.584 281.325 189.155 282.474 189.396 284.167C189.638 285.861 188.49 287.433 186.798 287.675C185.106 287.917 183.536 286.768 183.294 285.075C183.052 283.381 184.2 281.809 185.892 281.567ZM200.514 264.874C204.441 264.874 207.583 268.019 207.583 271.95C207.583 275.882 204.441 279.027 200.514 279.027C196.586 279.027 193.445 275.882 193.445 271.95C193.445 268.019 196.586 264.874 200.514 264.874Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 264,
    width: 25,
    height: 24
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 264,
    width: 25,
    height: 24
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M185.892 281.567C187.584 281.325 189.155 282.474 189.396 284.167C189.638 285.861 188.49 287.433 186.798 287.675C185.106 287.917 183.536 286.768 183.294 285.075C183.052 283.381 184.2 281.809 185.892 281.567ZM200.514 264.874C204.441 264.874 207.583 268.019 207.583 271.95C207.583 275.882 204.441 279.027 200.514 279.027C196.586 279.027 193.445 275.882 193.445 271.95C193.445 268.019 196.586 264.874 200.514 264.874Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.208 307.452C171.208 307.452 171.873 269.712 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L171.208 307.452Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.186 307.755C207.944 295.296 206.675 260.821 199.969 241.407L166.072 253.08C165.831 252.173 165.529 251.326 165.227 250.479L204.923 236.811C213.141 260.821 213.201 307.815 213.201 307.815L208.186 307.755Z",
    fill: "#301007"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.597 308.601C213.382 308.601 214.107 308.178 214.53 307.512C214.953 306.847 214.953 306 214.591 305.275C210.845 298.682 200.815 293.844 190.604 293.844C180.09 293.844 172.538 298.924 169.758 305.819C169.517 306.424 169.577 307.15 169.94 307.694C170.302 308.238 170.906 308.541 171.571 308.541C179.728 308.601 203.836 308.601 212.597 308.601Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 169,
    y: 293,
    width: 46,
    height: 16
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M212.597 308.601C213.382 308.601 214.107 308.178 214.53 307.512C214.953 306.847 214.953 306 214.591 305.275C210.845 298.682 200.815 293.844 190.604 293.844C180.09 293.844 172.538 298.924 169.758 305.819C169.517 306.424 169.577 307.15 169.94 307.694C170.302 308.238 170.906 308.541 171.571 308.541C179.728 308.601 203.836 308.601 212.597 308.601Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.221 303.219C215.678 304.065 214.711 304.61 213.623 304.61C203.352 304.61 179.365 304.61 169.999 304.549C169.153 304.549 168.368 304.186 167.885 303.521C167.582 303.945 167.341 304.368 167.099 304.791C166.676 305.578 166.676 306.545 167.16 307.331C167.643 308.118 168.489 308.602 169.456 308.602C179.062 308.662 203.835 308.662 214.348 308.662C215.496 308.662 216.584 307.997 217.067 307.029C217.611 306.001 217.43 304.852 216.765 303.945C216.644 303.642 216.403 303.461 216.221 303.219Z",
    fill: "#301007"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 96,
    height: 118
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.235 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 240.016 116.888 252.657 123.836 262.455C119.909 253.624 117.673 243.464 117.673 232.638C117.673 215.098 123.353 183.769 132.235 156.492Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 96,
    height: 118
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.762 156.492H193.562C201.296 182.62 207.278 208.566 207.278 226.227C207.278 240.016 203.109 252.657 196.16 262.455C200.088 253.624 202.323 243.464 202.323 232.638C202.323 215.098 196.644 183.769 187.762 156.492Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 96,
    height: 118
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.752 240.439C129.093 240.439 126.918 242.677 126.918 245.459C126.918 248.241 129.093 250.479 131.752 250.479C134.41 250.479 136.585 248.241 136.585 245.459C136.585 242.677 134.41 240.439 131.752 240.439ZM189.273 240.742C191.871 240.742 193.925 242.677 193.925 245.096C193.925 247.515 191.81 249.451 189.273 249.451C186.675 249.451 184.62 247.515 184.62 245.096C184.56 242.737 186.675 240.742 189.273 240.742ZM201.417 223.263C204.317 223.263 206.613 225.561 206.613 228.464C206.613 231.307 204.257 233.665 201.417 233.665C198.517 233.665 196.221 231.367 196.221 228.464C196.161 225.561 198.517 223.263 201.417 223.263ZM117.13 221.751C114.23 221.751 111.934 224.049 111.934 226.952C111.934 229.795 114.29 232.153 117.13 232.153C120.03 232.153 122.326 229.855 122.326 226.952C122.326 224.049 119.97 221.751 117.13 221.751ZM190.723 212.437C192.415 212.437 193.804 213.828 193.804 215.521C193.804 217.215 192.415 218.606 190.723 218.606C189.031 218.606 187.641 217.215 187.641 215.521C187.641 213.828 188.971 212.437 190.723 212.437ZM128.126 209.957C126.435 209.957 125.045 211.348 125.045 213.041C125.045 214.735 126.435 216.126 128.126 216.126C129.818 216.126 131.208 214.735 131.208 213.041C131.208 211.287 129.818 209.957 128.126 209.957ZM199.846 188.002C203.774 188.002 206.916 191.147 206.916 195.079C206.916 198.949 203.774 202.155 199.846 202.155C195.919 202.155 192.777 199.01 192.777 195.079C192.777 191.147 195.919 188.002 199.846 188.002ZM119.728 188.002C115.801 188.002 112.659 191.147 112.659 195.079C112.659 198.949 115.801 202.155 119.728 202.155C123.655 202.155 126.797 199.01 126.797 195.079C126.797 191.147 123.655 188.002 119.728 188.002ZM187.037 178.446C188.729 178.446 190.119 179.837 190.119 181.531C190.119 183.224 188.729 184.615 187.037 184.615C185.345 184.615 183.956 183.224 183.956 181.531C183.956 179.837 185.345 178.446 187.037 178.446ZM132.537 178.446C130.845 178.446 129.456 179.837 129.456 181.531C129.456 183.224 130.845 184.615 132.537 184.615C134.229 184.615 135.619 183.224 135.619 181.531C135.619 179.837 134.229 178.446 132.537 178.446Z",
    fill: "#673620"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 178,
    width: 96,
    height: 73
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M131.752 240.439C129.093 240.439 126.918 242.677 126.918 245.459C126.918 248.241 129.093 250.479 131.752 250.479C134.41 250.479 136.585 248.241 136.585 245.459C136.585 242.677 134.41 240.439 131.752 240.439ZM189.273 240.742C191.871 240.742 193.925 242.677 193.925 245.096C193.925 247.515 191.81 249.451 189.273 249.451C186.675 249.451 184.62 247.515 184.62 245.096C184.56 242.737 186.675 240.742 189.273 240.742ZM201.417 223.263C204.317 223.263 206.613 225.561 206.613 228.464C206.613 231.307 204.257 233.665 201.417 233.665C198.517 233.665 196.221 231.367 196.221 228.464C196.161 225.561 198.517 223.263 201.417 223.263ZM117.13 221.751C114.23 221.751 111.934 224.049 111.934 226.952C111.934 229.795 114.29 232.153 117.13 232.153C120.03 232.153 122.326 229.855 122.326 226.952C122.326 224.049 119.97 221.751 117.13 221.751ZM190.723 212.437C192.415 212.437 193.804 213.828 193.804 215.521C193.804 217.215 192.415 218.606 190.723 218.606C189.031 218.606 187.641 217.215 187.641 215.521C187.641 213.828 188.971 212.437 190.723 212.437ZM128.126 209.957C126.435 209.957 125.045 211.348 125.045 213.041C125.045 214.735 126.435 216.126 128.126 216.126C129.818 216.126 131.208 214.735 131.208 213.041C131.208 211.287 129.818 209.957 128.126 209.957ZM199.846 188.002C203.774 188.002 206.916 191.147 206.916 195.079C206.916 198.949 203.774 202.155 199.846 202.155C195.919 202.155 192.777 199.01 192.777 195.079C192.777 191.147 195.919 188.002 199.846 188.002ZM119.728 188.002C115.801 188.002 112.659 191.147 112.659 195.079C112.659 198.949 115.801 202.155 119.728 202.155C123.655 202.155 126.797 199.01 126.797 195.079C126.797 191.147 123.655 188.002 119.728 188.002ZM187.037 178.446C188.729 178.446 190.119 179.837 190.119 181.531C190.119 183.224 188.729 184.615 187.037 184.615C185.345 184.615 183.956 183.224 183.956 181.531C183.956 179.837 185.345 178.446 187.037 178.446ZM132.537 178.446C130.845 178.446 129.456 179.837 129.456 181.531C129.456 183.224 130.845 184.615 132.537 184.615C134.229 184.615 135.619 183.224 135.619 181.531C135.619 179.837 134.229 178.446 132.537 178.446Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.762 156.492H193.562C201.296 182.62 207.278 208.566 207.278 226.227C207.278 240.016 203.109 252.657 196.16 262.455C200.088 253.624 202.323 243.464 202.323 232.638C202.323 215.098 196.644 183.769 187.762 156.492Z",
    fill: "#301007"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 178,
    width: 95,
    height: 73
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 178,
    width: 96,
    height: 73
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M131.752 240.439C129.093 240.439 126.918 242.677 126.918 245.459C126.918 248.241 129.093 250.479 131.752 250.479C134.41 250.479 136.585 248.241 136.585 245.459C136.585 242.677 134.41 240.439 131.752 240.439ZM189.273 240.742C191.871 240.742 193.925 242.677 193.925 245.096C193.925 247.515 191.81 249.451 189.273 249.451C186.675 249.451 184.62 247.515 184.62 245.096C184.56 242.737 186.675 240.742 189.273 240.742ZM201.417 223.263C204.317 223.263 206.613 225.561 206.613 228.464C206.613 231.307 204.257 233.665 201.417 233.665C198.517 233.665 196.221 231.367 196.221 228.464C196.161 225.561 198.517 223.263 201.417 223.263ZM117.13 221.751C114.23 221.751 111.934 224.049 111.934 226.952C111.934 229.795 114.29 232.153 117.13 232.153C120.03 232.153 122.326 229.855 122.326 226.952C122.326 224.049 119.97 221.751 117.13 221.751ZM190.723 212.437C192.415 212.437 193.804 213.828 193.804 215.521C193.804 217.215 192.415 218.606 190.723 218.606C189.031 218.606 187.641 217.215 187.641 215.521C187.641 213.828 188.971 212.437 190.723 212.437ZM128.126 209.957C126.435 209.957 125.045 211.348 125.045 213.041C125.045 214.735 126.435 216.126 128.126 216.126C129.818 216.126 131.208 214.735 131.208 213.041C131.208 211.287 129.818 209.957 128.126 209.957ZM199.846 188.002C203.774 188.002 206.916 191.147 206.916 195.079C206.916 198.949 203.774 202.155 199.846 202.155C195.919 202.155 192.777 199.01 192.777 195.079C192.777 191.147 195.919 188.002 199.846 188.002ZM119.728 188.002C115.801 188.002 112.659 191.147 112.659 195.079C112.659 198.949 115.801 202.155 119.728 202.155C123.655 202.155 126.797 199.01 126.797 195.079C126.797 191.147 123.655 188.002 119.728 188.002ZM187.037 178.446C188.729 178.446 190.119 179.837 190.119 181.531C190.119 183.224 188.729 184.615 187.037 184.615C185.345 184.615 183.956 183.224 183.956 181.531C183.956 179.837 185.345 178.446 187.037 178.446ZM132.537 178.446C130.845 178.446 129.456 179.837 129.456 181.531C129.456 183.224 130.845 184.615 132.537 184.615C134.229 184.615 135.619 183.224 135.619 181.531C135.619 179.837 134.229 178.446 132.537 178.446Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.235 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 240.016 116.888 252.657 123.836 262.455C119.909 253.624 117.673 243.464 117.673 232.638C117.673 215.098 123.353 183.769 132.235 156.492Z",
    fill: "#9D6E51"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 156,
    width: 96,
    height: 118
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M193.562 156.492H126.434C118.7 182.62 112.719 208.566 112.719 226.227C112.719 257.314 133.806 273.523 159.908 273.523C186.01 273.523 207.278 257.374 207.278 226.227C207.278 208.627 201.296 182.68 193.562 156.492Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.168 142.461C178.941 162.057 186.071 201.914 186.071 215.401C186.071 235.057 175.134 247.335 160.089 247.335C145.045 247.335 133.625 235.057 133.625 215.401C133.625 201.914 140.694 162.057 145.468 142.461H174.168Z",
    fill: "#EFD36F"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.576 10.1289L133.023 12.1248L139.67 37.3453L147.222 35.3494L140.576 10.1289Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 10,
    width: 15,
    height: 28
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.576 10.1289L133.023 12.1248L139.67 37.3453L147.222 35.3494L140.576 10.1289Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.922 12.8501L135.32 10.6123L142.027 35.8933L133.629 38.0706L126.922 12.8501Z",
    fill: "#CE8710"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M136.043 -1C140.937 -1 144.925 2.99173 144.925 7.89068C144.925 12.7896 140.937 16.7814 136.043 16.7814C131.149 16.7814 127.161 12.7896 127.161 7.89068C127.1 2.99173 131.088 -1 136.043 -1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: -1,
    width: 18,
    height: 18
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.043 -1C140.937 -1 144.925 2.99173 144.925 7.89068C144.925 12.7896 140.937 16.7814 136.043 16.7814C131.149 16.7814 127.161 12.7896 127.161 7.89068C127.1 2.99173 131.088 -1 136.043 -1Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.017 1.60052C135.38 2.02388 134.534 3.29398 133.205 4.44312C131.875 5.59225 130.486 6.19706 130.123 5.83418C129.761 5.41081 130.607 4.14071 131.936 2.99158C133.265 1.78196 134.655 1.17715 135.017 1.60052Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: -1,
    width: 18,
    height: 18
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136.043 -1C140.937 -1 144.925 2.99173 144.925 7.89068C144.925 12.7896 140.937 16.7814 136.043 16.7814C131.149 16.7814 127.161 12.7896 127.161 7.89068C127.1 2.99173 131.088 -1 136.043 -1Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.656 3.29395C144.441 4.62452 144.925 6.19703 144.925 7.89049C144.925 12.7894 140.937 16.7812 136.043 16.7812C132.055 16.7812 128.671 14.12 127.523 10.5516C129.094 13.1523 131.934 14.8458 135.136 14.8458C140.031 14.8458 144.018 10.8541 144.018 5.9551C144.018 4.98741 143.898 4.14068 143.656 3.29395Z",
    fill: "#301007"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M179.424 10.1289L186.976 12.1248L180.33 37.3453L172.777 35.3494L179.424 10.1289Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 172,
    y: 10,
    width: 15,
    height: 28
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M179.424 10.1289L186.976 12.1248L180.33 37.3453L172.777 35.3494L179.424 10.1289Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.08 12.8501L184.681 10.6123L178.035 35.8933L186.434 38.0706L193.08 12.8501Z",
    fill: "#CE8710"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184.019 -1C179.125 -1 175.137 2.99173 175.137 7.89068C175.137 12.7896 179.125 16.7814 184.019 16.7814C188.913 16.7814 192.901 12.7896 192.901 7.89068C192.901 2.99173 188.913 -1 184.019 -1Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: -1,
    width: 18,
    height: 18
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M184.019 -1C179.125 -1 175.137 2.99173 175.137 7.89068C175.137 12.7896 179.125 16.7814 184.019 16.7814C188.913 16.7814 192.901 12.7896 192.901 7.89068C192.901 2.99173 188.913 -1 184.019 -1Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.987 1.60052C184.624 2.02388 185.47 3.29398 186.799 4.44312C188.128 5.59225 189.518 6.19706 189.881 5.83418C190.243 5.41081 189.397 4.14071 188.068 2.99158C186.739 1.78196 185.349 1.17715 184.987 1.60052Z",
    fill: "#C3A088"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: -1,
    width: 18,
    height: 18
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M184.019 -1C179.125 -1 175.137 2.99173 175.137 7.89068C175.137 12.7896 179.125 16.7814 184.019 16.7814C188.913 16.7814 192.901 12.7896 192.901 7.89068C192.901 2.99173 188.913 -1 184.019 -1Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.347 3.29395C175.561 4.62452 175.078 6.19703 175.078 7.89049C175.078 12.7894 179.066 16.7812 183.96 16.7812C187.948 16.7812 191.331 14.12 192.479 10.5516C190.908 13.1523 188.069 14.8458 184.866 14.8458C179.972 14.8458 175.984 10.8541 175.984 5.9551C175.984 4.98741 176.105 4.14068 176.347 3.29395Z",
    fill: "#301007"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M185.466 40.6106C185.406 41.1549 185.889 39.5824 186.131 39.0985C186.675 38.0704 187.339 37.1027 187.943 36.135C189.756 33.4133 191.689 30.6917 193.744 28.1515C200.028 20.4704 208.124 14.4828 217.006 10.0677C219.483 8.85812 224.136 5.83408 226.855 7.89042C230.54 10.733 227.338 21.4381 226.19 24.946C222.263 36.7398 208.487 49.0779 194.771 49.3198L185.466 40.6106Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 7,
    width: 44,
    height: 43
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M185.466 40.6106C185.406 41.1549 185.889 39.5824 186.131 39.0985C186.675 38.0704 187.339 37.1027 187.943 36.135C189.756 33.4133 191.689 30.6917 193.744 28.1515C200.028 20.4704 208.124 14.4828 217.006 10.0677C219.483 8.85812 224.136 5.83408 226.855 7.89042C230.54 10.733 227.338 21.4381 226.19 24.946C222.263 36.7398 208.487 49.0779 194.771 49.3198L185.466 40.6106Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.282 3.77821C225.343 3.35485 225.826 4.4435 226.068 4.86687C226.491 5.59264 226.733 6.43937 226.974 7.22562C227.578 9.64485 227.941 12.2455 227.518 14.6648C226.189 22.0434 221.718 28.3334 216.642 33.7162C214.95 35.4702 213.198 37.2241 211.325 38.8571C209.21 40.6715 207.035 42.4255 204.558 43.6956C204.075 43.9375 202.685 44.8447 202.081 44.6633C201.235 44.4213 200.208 42.4859 199.604 41.8811C197.247 39.5224 194.286 37.8289 191.205 36.6193C190.601 36.3774 188.728 35.4702 188.063 35.7726C187.942 35.8331 190.299 38.1918 190.42 38.3733C191.93 40.0062 193.38 41.6997 194.709 43.5141C196.945 46.4777 198.939 49.6227 200.449 53.0096C200.752 53.6749 201.477 56.6989 202.262 57.0014C203.048 57.3038 205.283 55.5498 205.827 55.2474C209.573 53.0096 213.077 50.5299 216.34 47.7478C225.101 40.3086 230.962 29.6035 232.473 18.2331C233.258 12.3665 232.412 5.59264 228.304 0.996094L225.282 3.77821Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 7,
    width: 44,
    height: 43
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M185.466 40.6106C185.406 41.1549 185.889 39.5824 186.131 39.0985C186.675 38.0704 187.339 37.1027 187.943 36.135C189.756 33.4133 191.689 30.6917 193.744 28.1515C200.028 20.4704 208.124 14.4828 217.006 10.0677C219.483 8.85812 224.136 5.83408 226.855 7.89042C230.54 10.733 227.338 21.4381 226.19 24.946C222.263 36.7398 208.487 49.0779 194.771 49.3198L185.466 40.6106Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.461 47.3849C187.34 47.2639 188.729 45.3285 188.85 45.2076C190.482 42.8488 192.294 40.6715 194.167 38.5547C199.303 32.688 205.345 26.9424 212.173 23.374C213.079 22.8901 214.046 22.4063 215.073 22.0434C217.067 21.2572 220.39 20.7128 219.665 24.0998C219.544 24.6441 219.363 25.1279 219.182 25.6723C217.732 29.3011 215.194 32.5671 212.535 35.2887C210.058 37.8289 207.097 39.8248 204.137 41.6392C199.786 44.3004 195.134 45.8729 190.482 47.8687L187.461 47.3849Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 21,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 21,
    width: 33,
    height: 27
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M187.461 47.3849C187.34 47.2639 188.729 45.3285 188.85 45.2076C190.482 42.8488 192.294 40.6715 194.167 38.5547C199.303 32.688 205.345 26.9424 212.173 23.374C213.079 22.8901 214.046 22.4063 215.073 22.0434C217.067 21.2572 220.39 20.7128 219.665 24.0998C219.544 24.6441 219.363 25.1279 219.182 25.6723C217.732 29.3011 215.194 32.5671 212.535 35.2887C210.058 37.8289 207.097 39.8248 204.137 41.6392C199.786 44.3004 195.134 45.8729 190.482 47.8687L187.461 47.3849Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.466 40.6106C185.406 41.1549 185.889 39.5824 186.131 39.0985C186.675 38.0704 187.339 37.1027 187.943 36.135C189.756 33.4133 191.689 30.6917 193.744 28.1515C200.028 20.4704 208.124 14.4828 217.006 10.0677C219.483 8.85812 224.136 5.83408 226.855 7.89042C230.54 10.733 227.338 21.4381 226.19 24.946C222.263 36.7398 208.487 49.0779 194.771 49.3198L185.466 40.6106Z",
    fill: "white"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.282 3.77821C225.343 3.35485 225.826 4.4435 226.068 4.86687C226.491 5.59264 226.733 6.43937 226.974 7.22562C227.578 9.64485 227.941 12.2455 227.518 14.6648C226.189 22.0434 221.718 28.3334 216.642 33.7162C214.95 35.4702 213.198 37.2241 211.325 38.8571C209.21 40.6715 207.035 42.4255 204.558 43.6956C204.075 43.9375 202.685 44.8447 202.081 44.6633C201.235 44.4213 200.208 42.4859 199.604 41.8811C197.247 39.5224 194.286 37.8289 191.205 36.6193C190.601 36.3774 188.728 35.4702 188.063 35.7726C187.942 35.8331 190.299 38.1918 190.42 38.3733C191.93 40.0062 193.38 41.6997 194.709 43.5141C196.945 46.4777 198.939 49.6227 200.449 53.0096C200.752 53.6749 201.477 56.6989 202.262 57.0014C203.048 57.3038 205.283 55.5498 205.827 55.2474C209.573 53.0096 213.077 50.5299 216.34 47.7478C225.101 40.3086 230.962 29.6035 232.473 18.2331C233.258 12.3665 232.412 5.59264 228.304 0.996094L225.282 3.77821Z",
    fill: "#EEC18F"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.531 40.6106C134.591 41.155 134.108 39.5825 133.866 39.0986C133.322 38.0704 132.658 37.1027 132.053 36.135C130.241 33.4134 128.307 30.6918 126.253 28.1516C119.969 20.531 111.812 14.4829 102.93 10.1283C100.453 8.91866 95.8007 5.89462 93.0817 7.95097C89.396 10.7936 92.5984 21.4987 93.7464 25.0066C97.6737 36.8003 111.45 49.1384 125.165 49.3803L134.531 40.6106Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 7,
    width: 44,
    height: 43
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M134.531 40.6106C134.591 41.155 134.108 39.5825 133.866 39.0986C133.322 38.0704 132.658 37.1027 132.053 36.135C130.241 33.4134 128.307 30.6918 126.253 28.1516C119.969 20.531 111.812 14.4829 102.93 10.1283C100.453 8.91866 95.8007 5.89462 93.0817 7.95097C89.396 10.7936 92.5984 21.4987 93.7464 25.0066C97.6737 36.8003 111.45 49.1384 125.165 49.3803L134.531 40.6106Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7142 3.77801C94.6538 3.35465 94.1704 4.4433 93.9287 4.86667C93.5058 5.59244 93.2641 6.43917 93.0224 7.22542C92.4182 9.64466 92.0557 12.2453 92.4786 14.6646C93.8079 22.0432 98.2791 28.3332 103.354 33.716C105.046 35.47 106.798 37.2239 108.671 38.8569C110.786 40.6713 112.961 42.4253 115.439 43.6954C115.922 43.9373 117.312 44.8445 117.916 44.6631C118.762 44.4211 119.789 42.4858 120.393 41.8809C122.75 39.5222 125.71 37.8287 128.792 36.6191C129.396 36.3772 131.209 35.47 131.934 35.7724C132.054 35.8329 129.698 38.1916 129.577 38.3731C128.067 40.006 126.617 41.6995 125.287 43.5139C123.052 46.4775 121.058 49.6225 119.547 53.0094C119.245 53.6747 118.52 56.6987 117.735 57.0012C116.949 57.3036 114.714 55.5496 114.17 55.2472C110.424 53.0094 106.919 50.5297 103.657 47.7476C94.9559 40.127 89.0346 29.4824 87.5845 18.0515C86.7991 12.1849 87.6449 5.411 91.7536 0.814453L94.7142 3.77801Z",
    fill: "#CE8710"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 7,
    width: 44,
    height: 43
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.531 40.6106C134.591 41.155 134.108 39.5825 133.866 39.0986C133.322 38.0704 132.658 37.1027 132.053 36.135C130.241 33.4134 128.307 30.6918 126.253 28.1516C119.969 20.531 111.812 14.4829 102.93 10.1283C100.453 8.91866 95.8007 5.89462 93.0817 7.95097C89.396 10.7936 92.5984 21.4987 93.7464 25.0066C97.6737 36.8003 111.45 49.1384 125.165 49.3803L134.531 40.6106Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.537 47.3849C132.657 47.2639 131.268 45.3285 131.147 45.2076C129.516 42.8488 127.703 40.6715 125.83 38.5547C120.694 32.688 114.652 26.9424 107.824 23.374C106.918 22.8901 105.951 22.4063 104.924 22.0434C102.93 21.2572 99.6071 20.7128 100.332 24.0998C100.453 24.6441 100.634 25.1279 100.815 25.6723C102.266 29.3011 104.803 32.5671 107.462 35.2887C109.939 37.8289 112.9 39.8248 115.86 41.6392C120.211 44.3004 124.863 45.8729 129.516 47.8687L132.537 47.3849Z",
    fill: "#F6DCBB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 21,
    width: 33,
    height: 27
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 21,
    width: 33,
    height: 27
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M132.54 47.3849C132.661 47.2639 131.272 45.3285 131.151 45.2076C129.519 42.8488 127.707 40.6715 125.834 38.5547C120.698 32.688 114.656 26.9424 107.828 23.374C106.922 22.8901 105.955 22.4063 104.928 22.0434C102.934 21.2572 99.611 20.7128 100.336 24.0998C100.457 24.6441 100.638 25.1279 100.819 25.6723C102.27 29.3011 104.807 32.5671 107.466 35.2887C109.943 37.8289 112.904 39.8248 115.864 41.6392C120.215 44.3004 124.867 45.8729 129.519 47.8687L132.54 47.3849Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.535 40.6106C134.595 41.155 134.112 39.5825 133.87 39.0986C133.326 38.0704 132.661 37.1027 132.057 36.135C130.245 33.4134 128.311 30.6918 126.257 28.1516C119.973 20.531 111.816 14.4829 102.934 10.1283C100.457 8.91866 95.8046 5.89462 93.0856 7.95097C89.4 10.7936 92.6023 21.4987 93.7503 25.0066C97.6776 36.8003 111.454 49.1384 125.169 49.3803L134.535 40.6106Z",
    fill: "white"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7181 3.77801C94.6577 3.35465 94.1743 4.4433 93.9327 4.86667C93.5097 5.59244 93.268 6.43917 93.0263 7.22542C92.4221 9.64466 92.0596 12.2453 92.4825 14.6646C93.8118 22.0432 98.283 28.3332 103.358 33.716C105.05 35.47 106.802 37.2239 108.675 38.8569C110.79 40.6713 112.965 42.4253 115.443 43.6954C115.926 43.9373 117.316 44.8445 117.92 44.6631C118.766 44.4211 119.793 42.4858 120.397 41.8809C122.754 39.5222 125.714 37.8287 128.796 36.6191C129.4 36.3772 131.212 35.47 131.938 35.7724C132.058 35.8329 129.702 38.1916 129.581 38.3731C128.071 40.006 126.62 41.6995 125.291 43.5139C123.056 46.4775 121.062 49.6225 119.551 53.0094C119.249 53.6747 118.524 56.6987 117.739 57.0012C116.953 57.3036 114.718 55.5496 114.174 55.2472C110.428 53.0094 106.923 50.5297 103.66 47.7476C94.9598 40.127 89.0385 29.4824 87.5884 18.0515C86.803 12.1849 87.6489 5.411 91.7575 0.814453L94.7181 3.77801Z",
    fill: "#EEC18F"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.73 176.269C137.132 176.572 87.4056 156.311 96.8917 105.567C110.305 33.2927 136.89 28.2728 160.032 27.668H160.576C183.536 28.3333 209.819 33.837 223.172 105.567C232.598 156.553 182.448 176.753 160.032 176.269H159.73Z",
    fill: "#E4B637"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 27,
    width: 130,
    height: 150
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.73 176.269C137.132 176.572 87.4056 156.311 96.8917 105.567C110.305 33.2927 136.89 28.2728 160.032 27.668H160.576C183.536 28.3333 209.819 33.837 223.172 105.567C232.598 156.553 182.448 176.753 160.032 176.269H159.73Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.238 56.6988C126.075 30.6921 143.899 28.0914 159.971 27.7285H160.515C176.466 28.2124 194.048 30.9945 207.704 56.6988C193.807 33.5952 176.406 30.9945 160.515 30.5106H159.971C143.959 30.934 126.316 33.2928 112.238 56.6988Z",
    fill: "#EFD36F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 27,
    width: 130,
    height: 150
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.73 176.269C137.132 176.572 87.4056 156.311 96.8917 105.567C110.305 33.2927 136.89 28.2728 160.032 27.668H160.576C183.536 28.3333 209.819 33.837 223.172 105.567C232.598 156.553 182.448 176.753 160.032 176.269H159.73Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.149 58.7549C106.678 69.0971 102.69 82.5843 99.4879 100.124C99.0649 102.301 98.8232 104.418 98.642 106.474C97.8565 108.591 97.3731 110.95 97.3731 113.611C97.3731 152.984 125.409 170.221 159.969 170.221C194.53 170.221 222.566 152.984 222.566 113.611C222.566 111.01 222.143 108.652 221.297 106.535C221.116 104.478 220.813 102.301 220.451 100.124C217.249 82.5843 213.321 69.1576 208.79 58.7549C214.348 69.8834 219.243 85.0036 223.049 105.567C223.472 107.805 223.774 109.982 223.955 112.099C224.801 114.276 225.224 116.635 225.224 119.357C225.224 159.637 195.98 177.237 159.909 177.237C123.838 177.237 94.5938 159.637 94.5938 119.357C94.5938 116.696 95.0771 114.276 95.923 112.099C96.1043 109.982 96.4064 107.865 96.8293 105.628C100.696 85.0036 105.59 69.8834 111.149 58.7549Z",
    fill: "#CE8710"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M160.393 92.624C181.057 92.624 225.345 93.1079 225.345 119.357C225.345 159.637 196.102 177.237 160.03 177.237C123.959 177.237 94.7149 159.637 94.7149 119.357C94.6545 92.6845 139.729 92.624 160.393 92.624Z",
    fill: "#F6DCBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 92,
    width: 132,
    height: 86
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M160.393 92.624C181.057 92.624 225.345 93.1079 225.345 119.357C225.345 159.637 196.102 177.237 160.03 177.237C123.959 177.237 94.7149 159.637 94.7149 119.357C94.6545 92.6845 139.729 92.624 160.393 92.624Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.149 58.7549C106.678 69.0971 102.69 82.5843 99.4879 100.124C99.0649 102.301 98.8232 104.418 98.642 106.474C97.8565 108.591 97.3731 110.95 97.3731 113.611C97.3731 152.984 125.409 170.221 159.969 170.221C194.53 170.221 222.566 152.984 222.566 113.611C222.566 111.01 222.143 108.652 221.297 106.535C221.116 104.478 220.813 102.301 220.451 100.124C217.249 82.5843 213.321 69.1576 208.79 58.7549C214.348 69.8834 219.243 85.0036 223.049 105.567C223.472 107.805 223.774 109.982 223.955 112.099C224.801 114.276 225.224 116.635 225.224 119.357C225.224 159.637 195.98 177.237 159.909 177.237C123.838 177.237 94.5938 159.637 94.5938 119.357C94.5938 116.696 95.0771 114.276 95.923 112.099C96.1043 109.982 96.4064 107.865 96.8293 105.628C100.696 85.0036 105.59 69.8834 111.149 58.7549Z",
    fill: "#EEC18F"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.788 35.833C142.265 35.833 144.259 37.8289 144.259 40.3086C144.259 42.7883 142.265 44.7842 139.788 44.7842C137.31 44.7842 135.316 42.7883 135.316 40.3086C135.316 37.8289 137.31 35.833 139.788 35.833Z",
    fill: "#673620"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.596 44.7842C166.073 44.7842 168.067 46.78 168.067 49.2598C168.067 51.7395 166.073 53.7353 163.596 53.7353C161.119 53.7353 159.125 51.7395 159.125 49.2598C159.125 46.78 161.119 44.7842 163.596 44.7842Z",
    fill: "#673620"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.42 35.833C183.474 35.833 185.106 37.466 185.106 39.5223C185.106 41.5787 183.474 43.2117 181.42 43.2117C179.366 43.2117 177.734 41.5787 177.734 39.5223C177.734 37.466 179.366 35.833 181.42 35.833Z",
    fill: "#673620"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.203 32.3853C155.983 32.0224 158.581 34.0787 158.943 36.9818C159.306 39.8849 157.372 42.546 154.593 42.9089C151.814 43.2718 149.216 41.2155 148.793 38.3124C148.43 35.4093 150.424 32.7481 153.203 32.3853Z",
    fill: "#673620"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.512 52.7676C153.022 52.7676 154.231 53.9772 154.231 55.4892C154.231 57.0012 153.022 58.2109 151.512 58.2109C150.001 58.2109 148.793 57.0012 148.793 55.4892C148.793 54.0377 150.001 52.7676 151.512 52.7676Z",
    fill: "#673620"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.395 46.2962C150.241 46.4171 150.906 47.1429 150.785 48.0501C150.664 48.8968 149.939 49.5621 149.033 49.4412C148.187 49.3202 147.522 48.5944 147.643 47.6872C147.764 46.8405 148.549 46.2357 149.395 46.2962Z",
    fill: "#673620"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.45 40.5508C172.296 40.5508 173.021 41.2766 173.021 42.1233C173.021 42.97 172.296 43.6958 171.45 43.6958C170.604 43.6958 169.879 42.97 169.879 42.1233C169.879 41.2161 170.604 40.5508 171.45 40.5508Z",
    fill: "#673620"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.911 55.1865C169.757 55.1865 170.482 55.9123 170.482 56.759C170.482 57.6058 169.757 58.3315 168.911 58.3315C168.065 58.3315 167.34 57.6662 167.34 56.759C167.34 55.9123 168.065 55.1865 168.911 55.1865Z",
    fill: "#673620"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.281 32.2041C168.792 32.2041 170 33.4137 170 34.9257C170 36.4378 168.792 37.6474 167.281 37.6474C165.771 37.6474 164.562 36.4378 164.562 34.9257C164.562 33.4137 165.771 32.2041 167.281 32.2041Z",
    fill: "#673620"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.091 48.6543C141.36 48.6543 142.327 49.6825 142.327 50.8921C142.327 52.1622 141.299 53.1299 140.091 53.1299C138.822 53.1299 137.855 52.1017 137.855 50.8921C137.855 49.622 138.883 48.6543 140.091 48.6543Z",
    fill: "#673620"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.029 58.9971C162.084 58.9971 163.715 60.6301 163.715 62.6864C163.715 64.7428 162.084 66.3757 160.029 66.3757C157.975 66.3757 156.344 64.7428 156.344 62.6864C156.344 60.6301 157.975 58.9971 160.029 58.9971Z",
    fill: "#673620"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.887 47.4453C178.337 47.4453 179.485 48.5945 179.485 50.046C179.485 51.4975 178.337 52.6467 176.887 52.6467C175.437 52.6467 174.289 51.4975 174.289 50.046C174.289 48.5945 175.497 47.4453 176.887 47.4453Z",
    fill: "#673620"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.226 104.963C122.51 104.963 127.586 107.261 127.586 110.043C127.586 112.825 122.51 115.124 116.226 115.124C109.943 115.124 104.867 112.825 104.867 110.043C104.928 107.201 110.003 104.963 116.226 104.963Z",
    fill: "#E96565"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.773 104.66C210.057 104.66 215.132 106.958 215.132 109.741C215.132 112.523 210.057 114.821 203.773 114.821C197.489 114.821 192.414 112.523 192.414 109.741C192.414 106.898 197.489 104.66 203.773 104.66Z",
    fill: "#E96565"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.863 103.39C146.495 102.725 148.912 104.418 150.301 107.14C151.691 109.861 151.51 112.643 149.939 113.309C148.307 113.974 145.891 112.281 144.501 109.559C143.111 106.837 143.292 104.055 144.863 103.39Z",
    fill: "#301007"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.134 103.39C173.503 102.725 171.086 104.418 169.696 107.14C168.306 109.861 168.488 112.643 170.059 113.309C171.69 113.974 174.107 112.281 175.497 109.559C176.886 106.837 176.765 104.055 175.134 103.39Z",
    fill: "#301007"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.767 168.104C119.247 155.343 112.117 135.324 99.1268 140.525C94.5952 142.339 91.272 150.262 91.0908 155.343C90.547 153.528 88.251 149.295 86.1362 151.714C85.2903 152.682 85.4112 157.278 88.0093 162.177C91.1512 168.104 102.692 169.858 107.767 168.104Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 139,
    width: 29,
    height: 30
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M107.767 168.104C119.247 155.343 112.117 135.324 99.1268 140.525C94.5952 142.339 91.272 150.262 91.0908 155.343C90.547 153.528 88.251 149.295 86.1362 151.714C85.2903 152.682 85.4112 157.278 88.0093 162.177C91.1512 168.104 102.692 169.858 107.767 168.104Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6011 168.225C92.5407 168.346 92.2386 165.988 93.447 160.121C96.8306 144.033 104.867 135.626 113.99 146.936C109.64 136.11 97.1327 135.687 91.3323 139.195C85.2297 142.823 82.2691 150.384 82.6921 157.641C82.8733 160.544 83.4775 163.629 85.2902 165.988L92.6011 168.225Z",
    fill: "#301007"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M212.293 168.104C200.813 155.343 207.943 135.324 220.933 140.525C225.465 142.339 228.788 150.262 228.969 155.343C229.513 153.528 231.809 149.295 233.924 151.714C234.769 152.682 234.649 157.278 232.051 162.177C228.848 168.104 217.368 169.858 212.293 168.104Z",
    fill: "#673620"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_197_181806",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 139,
    width: 29,
    height: 30
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M212.293 168.104C200.813 155.343 207.943 135.324 220.933 140.525C225.465 142.339 228.788 150.262 228.969 155.343C229.513 153.528 231.809 149.295 233.924 151.714C234.769 152.682 234.649 157.278 232.051 162.177C228.848 168.104 217.368 169.858 212.293 168.104Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_197_181806)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.397 168.225C227.457 168.346 227.759 165.988 226.551 160.121C223.167 144.033 215.131 135.626 206.008 146.936C210.358 136.11 222.865 135.687 228.666 139.195C234.768 142.823 237.729 150.384 237.306 157.641C237.125 160.544 236.52 163.629 234.708 165.988L227.397 168.225Z",
    fill: "#301007"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.851 137.198C163.718 137.198 166.799 143.73 166.799 148.69C166.799 153.649 163.657 155.101 159.851 155.101C156.044 155.101 152.902 153.589 152.902 148.69C152.902 143.73 156.044 137.198 159.851 137.198Z",
    fill: "#301007"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.737 65.0454C190.664 58.0901 198.519 58.0901 202.447 61.5375C206.374 65.0454 206.374 72.0007 202.447 78.956C199.969 83.613 194.048 88.3305 188.61 91.7779C187.462 92.5037 186.012 92.5037 184.864 91.7779C179.426 88.3305 173.505 83.6735 171.028 78.956C167.1 72.0007 167.1 64.9849 171.028 61.5375C174.955 58.0901 182.81 58.0901 186.737 65.0454Z",
    fill: "#F32F3C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.264 65.0454C137.192 58.0901 145.047 58.0901 148.974 61.5375C152.901 65.0454 152.901 72.0007 148.974 78.956C146.497 83.613 140.575 88.3305 135.137 91.7779C133.989 92.5037 132.539 92.5037 131.391 91.7779C125.953 88.3305 120.032 83.6735 117.555 78.956C113.628 72.0007 113.628 64.9849 117.555 61.5375C121.482 58.0901 129.337 58.0901 133.264 65.0454Z",
    fill: "#F32F3C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_181806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 320,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_197_181806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 322,
    fill: "white",
    transform: "translate(61 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeExcited);
export default __webpack_public_path__ + "static/media/giraffe_excited.0dc8aeb0354d90e0224ae755ad818d30.svg";
export { ForwardRef as ReactComponent };